export default ".spinner-border{\r\n    width: 5rem; \r\n    height: 5rem;\r\n}";